/* THIS FILE IS AUTO-GENERATED BY LABEL SERVICES */
const es_US = {
  BACK_TO_PAGES: 'Volver a las páginas',
  NO_PREFERENCES_FOUND: 'No se encontraron preferencias',
  CONFIRMATION: 'Confirmación',
  EXPORT: 'Exportar',
  ALL_CONDITIONS: 'Todas las condiciones',
  CLOSE: 'Cerrar',
  CERTIFIED: 'Con certificado',
  YEAR: 'Año',
  PAGE_PATH_INVALID: 'La ruta de acceso a la nueva página no es válida. Ajuste la dirección URL. ',
  CONTENT_TYPE: 'Tipo de contenido',
  SITEMAP_END_DATE: 'Quitar del mapa de sitio en',
  NONE: 'Ninguna',
  PATH_ERROR_MUST_END_IN_HTM: 'La ruta debe terminar en .htm',
  PAGE_SELECTED: '{count} Página seleccionada',
  SITECONTENT_NO_HISTORY: 'Sin Historial',
  FILTER_TYPE_CUSTOM_TOOLTIP: 'Páginas creadas específicamente para este concesionario. Son exclusivas de su sitio web y totalmente editables. ',
  SEARCH: 'Buscar',
  PAGE_ALIAS: 'Alias de la página',
  SELECT_A_CONDITION: 'Seleccione una condición',
  SITEMAP_MANAGE_PAGES: 'Administrar páginas',
  SITEMAP_PAGES: 'Páginas',
  PAGE_ID: 'ID de la página',
  DELETE_PAGE_CONFIRM: 'Are you sure you want to remove this page?: ',
  FILTERED_PAGES_COUNT: '{filtered} de {total} páginas',
  NO_INDEX_TOOLTIP: 'Impide que los motores de búsqueda indexen esta página. Desmarque esta opción para volver a permitir la indexación. ',
  SELECT_PAGE_ID: 'Seleccione la ID de la página',
  ARE_YOU_SURE_YOU_WANT_TO_RESTORE_THIS_REVISION_NOTE: "Nota: Estos cambios no se guardarán inmediatamente. Haga clic en 'Guardar' para aplicar los cambios a su sitio en vivo. ",
  BATCH_LIMIT_CONFIRM: 'Volver atrás y actualizar selecciones',
  CONDITION: 'Condición',
  REMOVE_PAGES: 'Eliminar páginas',
  NO_ITEMS_MATCH: 'No hay coincidencias de artículos',
  VIEW_LINK: 'Ver enlace',
  PICK_A_GRADIENT: 'Elige un degradado',
  FILTER_TYPE_CUSTOM: 'Costumbre',
  SITEMAP_END_DATE_INVALID: 'La fecha de finalización debe ser posterior a la fecha de inicio. ',
  DISCARD_CHANGES: 'Descartar cambios',
  SELECT_MAKE_TO_FILTER_BY_MODELS: 'Seleccione una marca para filtrar por modelos',
  DRAFT_OF_PAGE_EXISTS_ALREADY: 'El borrador de la página ya existe',
  ERROR_LOADING_SITEMAP: 'Error al cargar el mapa del sitio: {message} ',
  PICK_A_COLOR: 'Elige un color',
  BATCH_UPDATE_LIMIT_MSG_3: 'Por favor, reduzca su selección a {batchUpdateLimit} páginas o menos, y vuelva a intentarlo. ',
  DELETE: 'Borrar',
  PAGE_PATH: 'Ruta de la página',
  GO_TO_DRAFT: 'Ir al borrador',
  NO_INDEX: 'Sin índice',
  NO_FOLLOW: 'No seguir',
  SAVE: 'Guardar',
  CLEAR_FILTERS: 'Borrar filtros',
  SHOW_IN_HTML_SITEMAP: 'Mostrar en el mapa del sitio en HTML',
  YES_RESTORE_THIS_REVISION: 'Si',
  SITECONTENT_HISTORY: 'Historial de contenido',
  MODEL: 'Modelo',
  DELETE_PAGES_WARNING: 'Eliminar estas páginas podría generar errores 404 si alguna de ellas está enlazada en la navegación de su sitio. Para evitar enlaces no válidos, elimine los elementos asociados de su navegación antes de continuar. ',
  LINK_TO_DVS_WEB_COMPARISON: 'Enlace a la comparación de dvs-web con la revisión actual',
  INHERITED_DISTRIBUTED_PAGE_TOOLTIP: 'Esta página es {src} y se origina en un sitio principal',
  ARE_YOU_SURE_YOU_WANT_TO_RESTORE_THIS_REVISION: '¿Está seguro de que desea cargar esta revisión? ',
  CANCEL: 'Cancelar',
  NO_RESTORE_THIS_REVISION: 'No',
  STAY: 'Permanecer',
  NEW: 'Nuevo',
  NO_SITEMAP_DATA: 'No hay datos del mapa del sitio',
  PAGE_ID_MISSING_ERROR: 'Esta página no tiene un ID de página correspondiente y generará un error 404',
  ERROR_MESSAGE_PAGE_DETAIL: 'No se pudieron cargar los detalles de la página. Inténtelo de nuevo. ',
  PAGES_SELECTED: '{count} Páginas seleccionadas',
  FILTER_TYPE_SITE_DEFAULT_TOOLTIP: 'Páginas que vienen incluidas de serie con la plantilla de tu sitio web. Estas páginas están preconfiguradas y se incluyen en cada configuración del sitio. ',
  SITEMAP_START_DATE: 'Agregar al mapa de sitio en',
  FILTER_TYPE_PROGRAM_TOOLTIP: 'Contenido distribuido gestionado por un fabricante de equipos originales (OEM) o un programa de socios. Las ediciones pueden estar limitadas o ser reemplazadas por actualizaciones del programa. ',
  BODY_STYLE_LOCALIZATION_WARNING: 'Los estilos de cuerpo están localizados y es posible que no arrojen resultados para sitios multilingües. ',
  USED: 'Usado',
  DELETE_PAGE_WARNING: 'Deleting this page will result in a 404 error if the page is currently linked in your site navigation. To avoid invalid links, delete the associated item from your navigation. ',
  DELETE_PAGES_CONFIRM: '¿Estás seguro de que deseas eliminar las siguientes páginas?: ',
  DONE: 'Listo',
  SHOW_IN_HTML_SITEMAP_TOOLTIP: 'Incluye esta página en el mapa HTML de tu sitio, lo que facilita que los visitantes y los motores de búsqueda la encuentren. Desmarca esta opción para excluirla. ',
  FILTER_TYPE_PROGRAM: 'Programa',
  NO_FOLLOW_TOOLTIP: 'Impide que los motores de búsqueda sigan los enlaces de esta página. Desmarque esta opción para permitir que los motores de búsqueda sigan los enlaces con normalidad. ',
  BATCH_UPDATE_LIMIT_MSG_2: 'Para ayudar a prevenir la pérdida accidental de datos y gestionar el riesgo, las actualizaciones masivas están limitadas a {batchUpdateLimit} páginas a la vez. ',
  BATCH_UPDATE_LIMIT_MSG_1: 'Has seleccionado más de {batchUpdateLimit} páginas. ',
  BATCH_DELETE_LIMIT_MSG_2: 'Para ayudar a prevenir la pérdida accidental de datos y gestionar el riesgo, las eliminaciones masivas están limitadas a {batchDeleteLimit} páginas a la vez. ',
  BATCH_DELETE_LIMIT_MSG_1: 'Has seleccionado más de {batchDeleteLimit} páginas. ',
  BATCH_DELETE_LIMIT_MSG_3: 'Por favor, reduzca su selección a {batchDeleteLimit} páginas o menos, y vuelva a intentarlo. ',
  VIEW_MORE: 'Ver más',
  NO_MATCHING_RESULTS: 'No hay resultados coincidentes',
  BATCH_UPDATE_LIMIT_TITLE: 'Se ha alcanzado el límite de actualizaciones masivas. ',
  MAKE: 'Marca',
  BODYSTYLE: 'Estilo de carrocería',
  PAGE_ALIAS_INVALID: 'Alias de la página no válido para su nueva página. Este alias ya existe. ',
  BATCH_EDIT_PAGE_DETAILS: 'Detalles de la página de edición por lotes',
  CLEAR_SEARCH_AND_FILTERS: 'Borrar búsqueda y filtros',
  OK: 'Ok',
  SHOW_IN_XML_SITEMAP_TOOLTIP: 'Incluye esta página en el mapa del sitio XML de tu sitio, lo que facilita que los motores de búsqueda la detecten e indexen. Desmarca esta opción para excluirla. ',
  PATH_ERROR_BEGIN_WITH: 'La ruta debe comenzar con &#8220;/&#8221; o &#8220;http:&#8221; ',
  OR: 'o',
  PATH_ERROR_MUST_NOT_CONTAIN_PLUS: 'La ruta no debe contener "+". ',
  UNSAVED_CHANGES: 'Cambios no guardados',
  SHOW_IN_XML_SITEMAP: 'Mostrar en el mapa del sitio en XML',
  SITEMAP_DELETE: 'Eliminar ({count}) ',
  BATCH_DELETE_LIMIT_TITLE: 'Se ha alcanzado el límite de eliminación masiva. ',
  PAGE_DETAILS: 'Detalles de la página',
  UNSAVED_CHANGES_MESSAGE: 'You have unsaved changes. If you leave now, those changes will be lost. ',
  DRAFT_OF_PAGE_EXISTS_ALREADY_DESCRIPTION: 'Tiene cambios en un borrador no publicado de la página actual. Publique o elimine el borrador de la página antes de continuar. ',
  SITEMAP_START_DATE_REQUIRED: 'This field is required',
  FILTER_TYPE_SITE_DEFAULT: 'Configuración predeterminada del sitio',
  REMOVE_PAGE: 'Eliminar página'
}
export default es_US;